import { getApi } from "../utils/api";
import { API_GET_MAIN_EMPLOYEE_LIST } from "../config/Endpoints";
import Cookies from "js-cookie";

export const fetchMainEmployeesListService = async (set, projectId) => {
  set({ loading: true });
  try {
    const accessToken = Cookies.get("accessToken");
    const url = `${API_GET_MAIN_EMPLOYEE_LIST}/${projectId}`;
    const res = await getApi(url, accessToken);
    const users = res.data?.data || [];
    const options = users.map((u) => ({
      value: u.employeeId,
      label: u.employeeName,
    }));
    set({ mainEmployeeList: options, loading: false });
  } catch (err) {
    console.error("Error fetching main employees:", err);
    set({ loading: false });
  }
};
